import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import { fetchUserProducts } from '../../../slice/product/productSlice';
import { fetchCategoryDropdown } from '../../../slice/category/categorySlice';
import Header from '../Header';
import Footer from '../components/Footer';
import { addToCart, fetchCart } from "../../../slice/cart/cartSlice";
import { toast } from "react-toastify";
import Popuplogin from "../components/Popuplogin"
import { fetchAllSubCategories } from "../../../slice/subCategory/subCategorySlice";

const Product = () => {
  const { categoryId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [imageFiles, setImageFiles] = useState([]);

  const { userProducts = [], loading, userPagination } = useSelector((state) => state.product);
  const { dropdownCategories = [] } = useSelector((state) => state.category);
  const { user, token } = useSelector((state) => state.auth);

  const [filters, setFilters] = useState({
    search: '',
    minPrice: 0,
    maxPrice: 10000,
    selectedCategory: categoryId || '',
    sortBy: 'latest',
    limit: 12,
    page: 1
  });

  useEffect(() => {
    dispatch(fetchCategoryDropdown());
  }, [dispatch]);

  // Fetch products when categoryId changes
  useEffect(() => {
    if (categoryId) {
      dispatch(fetchUserProducts({
        categoryId,
        search: filters.search,
        minPrice: filters.minPrice,
        maxPrice: filters.maxPrice,
        sortBy: filters.sortBy,
        page: filters.page,
        limit: filters.limit
      }));
    }
  }, [dispatch, categoryId, filters]);

  const handleReset = () => {
    setFilters({
      search: '',
      minPrice: 0,
      maxPrice: 10000,
      selectedCategory: categoryId || '',
      sortBy: 'latest',
      limit: 12,
      page: 1
    });
  };

  const handlePageChange = (newPage) => {
    setFilters(prev => ({ ...prev, page: newPage }));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const { allSubCategories = [] } = useSelector((state) => state.subCategory);
  const [openCategory, setOpenCategory] = useState(null);

  useEffect(() => {
    dispatch(fetchAllSubCategories());
  }, [dispatch]);

  const handleSubCategoryClick = (subCategoryId) => {
    navigate(`/product/${subCategoryId}`);
  };

const groupedData = useMemo(() => {
  return dropdownCategories.map((category) => {
    const subcategories = allSubCategories.filter(
      (sub) => sub.category?._id === category._id
    );

    return {
      id: category._id,
      name: category.name,
      status: category.status ?? true,
      subcategories: subcategories.map((sub) => ({
        id: sub._id,
        name: sub.name,
        status: sub.status,
        image: sub.image,
      })),
    };
  });
}, [dropdownCategories, allSubCategories]);
  const toggleCategory = (id) => {
    setOpenCategory(openCategory === id ? null : id);
  };

  const handleCategoryClick = (categoryId) => {
    navigate(`/product/${categoryId}`, { replace: false });
  };

  // Filter categories based on search
  const filteredCategories = useMemo(() => {
    if (!filters.search) return dropdownCategories;
    
    return dropdownCategories.filter(cat => 
      cat.name.toLowerCase().includes(filters.search.toLowerCase())
    );
  }, [dropdownCategories, filters.search]);

  // Check if we're on category listing page (no categoryId) or product page (has categoryId)
  const isListingPage = !categoryId;

   useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [categoryId]);
  return (
    <div className="page-wraper">
      <Header dropdownCategories={dropdownCategories} loading={loading} />
      <div className="page-content">
    


  <div className="dz-bnr-inr HeadingHeight">
          <div className="container">
            <div className="dz-bnr-inr-entry HeadCont">
              <h1>All Categories</h1>
              <nav aria-label="breadcrumb" className="breadcrumb-row">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/"> Home</a>
                  </li>
                  <li className="breadcrumb-item">
                    Category
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <section className="content-inner-3 pt-3 z-index-unset">
          <div className="container-fluid">
            <div className="row mt-xl-2 mt-0">
              {/* Sidebar Filters */}
              <div className="col-20 col-xl-3">
                <div className="sticky-xl-top">
                  <a href="#" className="panel-close-btn">
                    <svg width={35} height={35} viewBox="0 0 51 50" fill="none">
                      <path d="M37.748 12.5L12.748 37.5" stroke="white" strokeWidth="1.25"
                        strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M12.748 12.5L37.748 37.5" stroke="white" strokeWidth="1.25"
                        strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </a>

                  <div className="shop-filter">
                    <aside>
                      <div className="d-flex align-items-center justify-content-between m-b30">
                        <h6 className="title mb-0 fw-normal">
                          <svg className="me-2" width={20} height={20}>
                            <path d="M2.54,5H15v.5A1.5,1.5,0,0,0,16.5,7h2A1.5,1.5,0,0,0,20,5.5V5h2.33a.5.5,0,0,0,0-1H20V3.5A1.5,1.5,0,0,0,18.5,2h-2A1.5,1.5,0,0,0,15,3.5V4H2.54a.5.5,0,0,0,0,1ZM16,3.5a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.5v2a.5.5,0,0,1-.5.5h-2a.5.5,0,0,1-.5-.5Z" />
                          </svg>
                          Filter
                        </h6>
                        <button onClick={handleReset}
                          className="btn btn-sm font-14 btn-secondary btn-sharp">
                          RESET
                        </button>
                      </div>

                      {/* Search */}
                      <div className="widget widget_search">
                        <div className="form-group">
                          <div className="input-group">
                            <input
                              type="search"
                              className="form-control"
                              placeholder={isListingPage ? "Search Category" : "Search Product"}
                              value={filters.search}
                              onChange={(e) => setFilters(prev => ({
                                ...prev,
                                search: e.target.value
                              }))}
                            />
                            <div className="input-group-addon">
                              <button className="btn">
                                <svg width={20} height={20} viewBox="0 0 20 20" fill="none">
                                  <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z"
                                    stroke="#0D775E" strokeWidth={2} />
                                  <path d="M17.5 17.5L13.875 13.875"
                                    stroke="#0D775E" strokeWidth={2} />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Price Range - Only show for product pages */}
                      {!isListingPage && (
                        <div className="widget">
                          <h6 className="widget-title">Price Range</h6>
                          <div className="price-slide range-slider">
                            <div className="form-group mb-2">
                              <label>Min: ₹{filters.minPrice}</label>
                              <input
                                type="range"
                                className="form-range"
                                min="0"
                                max="10000"
                                step="100"
                                value={filters.minPrice}
                                onChange={(e) => setFilters(prev => ({
                                  ...prev,
                                  minPrice: Number(e.target.value)
                                }))}
                              />
                            </div>
                            <div className="form-group">
                              <label>Max: ₹{filters.maxPrice}</label>
                              <input
                                type="range"
                                className="form-range"
                                min="0"
                                max="10000"
                                step="100"
                                value={filters.maxPrice}
                                onChange={(e) => setFilters(prev => ({
                                  ...prev,
                                  maxPrice: Number(e.target.value)
                                }))}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {/* Categories */}
                      <div className="widget widget_categories">
                        <div className="card mt-3 shadow-sm">
                          <div className="card-header text-center text-white d-flex justify-content-center">
                            <h5 className="mb-0">Categories & Subcategories</h5>
                          </div>

                          <div className="card-body p-0">
                            {loading ? (
                              <p className="text-center p-4">Loading...</p>
                            ) : groupedData.length === 0 ? (
                              <p className="text-center p-4 text-muted">No categories found</p>
                            ) : (
                              groupedData.map((category) => (
                                <div key={category.id} className="border-bottom">
                                  <div
                                    className="p-3 d-flex justify-content-between align-items-center"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => toggleCategory(category.id)}
                                  >
                                    <div>
                                      <strong>{category.name} <span className="COINT">
                                        {category.subcategories.length}
                                      </span></strong>
                                    </div>
                                  </div>

                                {openCategory === category.id && (
  <div className="ps-4 pb-3">
    {category.subcategories.length > 0 ? (
      category.subcategories.map((sub) => (
        <div
          key={sub.id}
          className="py-1 d-flex align-items-center gap-3"
          style={{ cursor: "pointer" }}
          onClick={() => handleSubCategoryClick(sub.id)}
        >
          {sub.image && (
            <img
              src={`${process.env.REACT_APP_API_URL}/uploads/subcategories/${sub.image}`}
              alt={sub.name}
              className="imgSUB"
              style={{
                objectFit: "cover",
                borderRadius: "4px",
              }}
            />
          )}
          <span>{sub.name}</span>
        </div>
      ))
    ) : (
      <div className=" BlackColor">
        No subcategories found
      </div>
    )}
  </div>
)}
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      </div>
                    </aside>
                  </div>
                </div>
              </div>

              {/* Content Area - Categories or Products */}
              <div className="col-80 col-xl-9">
                {isListingPage ? (
                  // Category Listing Page
                  <>
                    <div className="RE_filter-wrapper">
                      <div className="RE_filter-left-area">
                        <span className="RE_filter-results-text">
                          Showing <strong>{filteredCategories.length}</strong> of <strong>{dropdownCategories.length}</strong> Categories
                        </span>
                      </div>

                      <div className="RE_filter-right-area">
                        <div className="RE_form-group">
                          <div className="RE_custom-select-wrapper">
                            <select
                              className="RE_default-select"
                              value={filters.limit}
                              onChange={(e) => setFilters(prev => ({
                                ...prev,
                                limit: Number(e.target.value),
                                page: 1
                              }))}
                            >
                              <option value={9}>9 Items</option>
                              <option value={12}>12 Items</option>
                              <option value={18}>18 Items</option>
                              <option value={24}>24 Items</option>
                            </select>
                            <span className="RE_select-icon">▼</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {loading ? (
                      <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : (
                      <div className="row gx-xl-4 g-3">
                        {filteredCategories.length > 0 ? (
                          filteredCategories.map((cat) => (
                            <div key={cat._id} className="col-lg-4 col-xl-3 col-md-6 col-sm-6 relative mobilecard">
                              <div 
                                className="SP_card" 
                               
                                onClick={() => handleCategoryClick(cat._id)}
                                style={{ cursor: 'pointer' }}
                              >
                              
                                <div className="SP_image_wrapper2 CateGAmin">
                                  <img
                                    src={`${process.env.REACT_APP_API_URL}/uploads/${cat.image}`}
                                    alt={cat.name}
                                    className='SP_frame_image'
                                  />
                               
                                </div>
                               <div
                      className="SP_customize_button2"
                   
                 
                    >
                     
                       <span className="d-md-block">{cat.name}</span>
                    </div>
                              </div>
                            </div>
                          ))
                        ) : (
                          <div className="col-12">
                            <p className="text-center">No categories found matching your search</p>
                          </div>
                        )}
                      </div>

                      
                    )}
                  </>
                ) : (
                  // Product Listing Page
                  <>
                    <div className="RE_filter-wrapper">
                      <div className="RE_filter-left-area">
                        <span className="RE_filter-results-text">
                          Showing <strong>{((filters.page - 1) * filters.limit) + 1}–
                            {Math.min(filters.page * filters.limit, userPagination?.total || 0)}</strong> of{' '}
                          <strong>{userPagination?.total || 0}</strong> Results
                        </span>
                      </div>

                      <div className="RE_filter-right-area">
                        <div className="RE_form-group">
                          <div className="RE_custom-select-wrapper">
                            <select
                              className="RE_default-select"
                              value={filters.limit}
                              onChange={(e) => setFilters(prev => ({
                                ...prev,
                                limit: Number(e.target.value),
                                page: 1
                              }))}
                            >
                              <option value={9}>9 Products</option>
                              <option value={12}>12 Products</option>
                              <option value={18}>18 Products</option>
                              <option value={24}>24 Products</option>
                            </select>
                            <span className="RE_select-icon">▼</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    {loading ? (
                      <div className="text-center py-5">
                        <div className="spinner-border text-primary" role="status">
                          <span className="visually-hidden">Loading...</span>
                        </div>
                      </div>
                    ) : userProducts.length > 0 ? (
                      <div className="row g-3">
                        {userProducts.map((product) => (
                          <div key={product._id} className="col-lg-4 col-md-6 col-sm-6">
                            {/* Your product card component here */}
                            <div className="shop-card2">
                              <div className="dz-media">
                                <img
                                  src={`${process.env.REACT_APP_API_URL}/uploads/products/${product.image}`}
                                  alt={product.name}
                                  className='productimg'
                                />
                              </div>
                              <div className="dz-content">
                                <h6>{product.name}</h6>
                                <p>₹{product.price}</p>
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className="text-center py-5">
                        <p>No products found</p>
                        <p className="text-muted">Try adjusting your filters</p>
                      </div>
                    )}

                    {/* Pagination */}
                    {userPagination?.totalPages > 1 && (
                      <div className="row page mt-0">
                        <div className="col-md-6">
                          <p className="page-text">
                            Showing {((filters.page - 1) * filters.limit) + 1}–
                            {Math.min(filters.page * filters.limit, userPagination.total)} of {userPagination.total} Results
                          </p>
                        </div>
                        <div className="col-md-6">
                          <nav aria-label="Blog Pagination">
                            <ul className="pagination style-1">
                              <li className={`page-item ${filters.page === 1 ? 'disabled' : ''}`}>
                                <a className="page-link prev"
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (filters.page > 1) handlePageChange(filters.page - 1);
                                  }}>
                                  Prev
                                </a>
                              </li>
                              {[...Array(userPagination.totalPages)].map((_, i) => (
                                <li key={i + 1} className={`page-item ${filters.page === i + 1 ? 'active' : ''}`}>
                                  <a className="page-link"
                                    href="#"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handlePageChange(i + 1);
                                    }}>
                                    {i + 1}
                                  </a>
                                </li>
                              ))}
                              <li className={`page-item ${filters.page === userPagination.totalPages ? 'disabled' : ''}`}>
                                <a className="page-link next"
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    if (filters.page < userPagination.totalPages) handlePageChange(filters.page + 1);
                                  }}>
                                  Next
                                </a>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>

      <Footer />
    </div>
  );
};

export default Product;